import { ActivityCategoryDto, ActivityTypeDto } from '@/api/generated';

export type ActivityLogTranslation = {
  button: {
    offer: string;
    process: string;
  };
  category: Record<ActivityCategoryDto, string>;
  empty: string;
  error: string;
  field: Record<string, string>;
  loadMore: string;
  scope: {
    offer: string;
    process: string;
  };
  title: string;
  type: Record<ActivityTypeDto, string>;
  value: {
    added: string;
    changed: string;
    counted: string;
    empty: string;
    removed: string;
  };
};

export const activityLogTranslation: ActivityLogTranslation = {
  button: {
    offer: 'Historia zmian oferty',
    process: 'Historia zmian',
  },
  category: {
    [ActivityCategoryDto.Email]: 'Maile',
    [ActivityCategoryDto.Money]: 'Pieniądze',
    [ActivityCategoryDto.Note]: 'Notatki',
    [ActivityCategoryDto.Offer]: 'Oferta',
    [ActivityCategoryDto.OfferContent]: 'Treść oferty',
    [ActivityCategoryDto.Process]: 'Proces',
  },
  empty: 'Brak zarejestrowanych zmian.',
  error: 'Nie udało się wczytać historii zmian.',
  field: {
    approvalRequested: 'Prośba o akceptację',
    approvalStatus: 'Decyzja',
    comment: 'Komentarz',
    contacts: 'Kontakty',
    copiedFromOfferId: 'Skopiowano z oferty',
    customerId: 'Klient',
    dishAdded: 'Dodano danie',
    dishRemoved: 'Usunięto danie',
    dishSelected: 'Zaznaczono danie',
    dishUnselected: 'Odznaczono danie',
    element: 'Składowa',
    eventDateFrom: 'Termin od',
    eventDateTo: 'Termin do',
    firstTime: 'Pierwsza wysyłka',
    group: 'Grupa',
    inquirySource: 'Źródło zapytania',
    location: 'Miejsce',
    minimumPrice: 'Cena minimalna',
    name: 'Nazwa',
    noOfGuests: 'Liczba osób',
    offerPrint: 'Szablon wydruku',
    overriddenPrice: 'Cena specjalna',
    owner: 'Opiekun',
    position: 'Pozycja',
    positionsAdded: 'Dodanych pozycji',
    positionsRemoved: 'Usuniętych pozycji',
    price: 'Cena',
    quantity: 'Ilość',
    realizationContact: 'Kontakt realizacji',
    schedule: 'Harmonogram',
    selected: 'Zaznaczona',
    sentAt: 'Wysłano',
    skipReason: 'Powód pominięcia',
    status: 'Status',
    subgroup: 'Podgrupa',
    subject: 'Temat',
    text: 'Treść',
  },
  loadMore: 'Pokaż starsze',
  scope: {
    offer: 'Ta oferta',
    process: 'Cały proces',
  },
  title: 'Historia zmian',
  type: {
    [ActivityTypeDto.EmailSent]: 'Wysłano maila',
    [ActivityTypeDto.MultiOfferCreated]: 'Utworzono grupę ofert',
    [ActivityTypeDto.MultiOfferStatusChanged]: 'Zmieniono status grupy ofert',
    [ActivityTypeDto.MultiOfferUpdated]: 'Zmieniono grupę ofert',
    [ActivityTypeDto.NoteAdded]: 'Dodano notatkę',
    [ActivityTypeDto.NoteDeleted]: 'Usunięto notatkę',
    [ActivityTypeDto.OfferCopiedAsVersion]: 'Utworzono nową wersję oferty',
    [ActivityTypeDto.OfferCreated]: 'Utworzono ofertę',
    [ActivityTypeDto.OfferDishesChanged]: 'Zmieniono dania',
    [ActivityTypeDto.OfferDishRemoved]: 'Usunięto danie',
    [ActivityTypeDto.OfferDishUpdated]: 'Zmieniono pozycję dania',
    [ActivityTypeDto.OfferElementAdded]: 'Dodano składową',
    [ActivityTypeDto.OfferElementCommentChanged]: 'Zmieniono komentarz składowej',
    [ActivityTypeDto.OfferElementDeleted]: 'Usunięto składową',
    [ActivityTypeDto.OfferElementItemAdded]: 'Dodano pozycję składowej',
    [ActivityTypeDto.OfferElementItemDeleted]: 'Usunięto pozycję składowej',
    [ActivityTypeDto.OfferElementItemUpdated]: 'Zmieniono pozycję składowej',
    [ActivityTypeDto.OfferElementRestored]: 'Przywrócono składową',
    [ActivityTypeDto.OfferElementSkipped]: 'Pominięto składową',
    [ActivityTypeDto.OfferElementUpdated]: 'Zmieniono składową',
    [ActivityTypeDto.OfferGroupAdded]: 'Dodano grupę',
    [ActivityTypeDto.OfferGroupCommentChanged]: 'Zmieniono komentarz grupy',
    [ActivityTypeDto.OfferGroupDeleted]: 'Usunięto grupę',
    [ActivityTypeDto.OfferGroupInsertedFromLibrary]: 'Wstawiono zestaw z biblioteki',
    [ActivityTypeDto.OfferGroupSelectionChanged]: 'Zmieniono zaznaczenie grupy',
    [ActivityTypeDto.OfferGroupUpdated]: 'Zmieniono grupę',
    [ActivityTypeDto.OfferPriceOverrideAccepted]: 'Rozpatrzono cenę specjalną',
    [ActivityTypeDto.OfferPriceOverrideRequested]: 'Ustawiono cenę specjalną',
    [ActivityTypeDto.OfferScheduleChanged]: 'Zmieniono harmonogram',
    [ActivityTypeDto.OfferSent]: 'Wysłano ofertę',
    [ActivityTypeDto.OfferStatusChanged]: 'Zmieniono status oferty',
    [ActivityTypeDto.OfferStructureReordered]: 'Zmieniono kolejność w ofercie',
    [ActivityTypeDto.OfferSubgroupAdded]: 'Dodano podgrupę',
    [ActivityTypeDto.OfferSubgroupCommentChanged]: 'Zmieniono komentarz podgrupy',
    [ActivityTypeDto.OfferSubgroupDeleted]: 'Usunięto podgrupę',
    [ActivityTypeDto.OfferSubgroupPortionsDistributed]: 'Rozdzielono porcje',
    [ActivityTypeDto.OfferSubgroupSelectionChanged]: 'Zmieniono zaznaczenie dań',
    [ActivityTypeDto.OfferSubgroupUpdated]: 'Zmieniono podgrupę',
    [ActivityTypeDto.OfferUpdated]: 'Zmieniono ofertę',
    [ActivityTypeDto.ProcessContactsChanged]: 'Zmieniono kontakty',
    [ActivityTypeDto.ProcessCreated]: 'Utworzono proces',
    [ActivityTypeDto.ProcessCustomerChanged]: 'Zmieniono klienta',
    [ActivityTypeDto.ProcessOwnerChanged]: 'Zmieniono opiekuna',
    [ActivityTypeDto.ProcessStatusChanged]: 'Zmieniono status procesu',
    [ActivityTypeDto.ProcessUpdated]: 'Zmieniono proces',
  },
  value: {
    added: 'dodano',
    changed: 'zmian',
    counted: '{{total}} zmian',
    empty: '—',
    removed: 'usunięto',
  },
};
